import { render, staticRenderFns } from "./customWord.vue?vue&type=template&id=66e81dae&scoped=true"
import script from "./customWord.vue?vue&type=script&lang=js"
export * from "./customWord.vue?vue&type=script&lang=js"
import style0 from "./customWord.vue?vue&type=style&index=0&id=66e81dae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e81dae",
  null
  
)

export default component.exports